import { Dispatch, SetStateAction } from 'react';

import { GetApp, RotateLeft } from '@mui/icons-material';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import Sidebar from '../../../Components/Sidebar/Sidebar';
import SidebarForm from '../../../Components/Sidebar/SidebarForm';
import SidebarGroup from '../../../Components/Sidebar/SidebarGroup';
import Sort, { SortItem } from '../../../Components/Sort';
import { VehicleArrivalsOverviewQuery } from './VehicleArrivalsOverview';
import { Compound, TransportOrderStatus } from 'system/Domain';

interface Props {
	query: VehicleArrivalsOverviewQuery
	setQuery: Dispatch<SetStateAction<VehicleArrivalsOverviewQuery>>
	resetQuery: () => VehicleArrivalsOverviewQuery
	triggerExport: () => void
	compounds: Compound[]
}

const sortItems: SortItem[] = [
	{
		title: "Erstellungsdatum",
		field: "dateCreated"
	}
];

const VehicleArrivalsOverviewSidebar = (props: Props) => {
	return (
		<Sidebar>
			<SidebarGroup>
				<SidebarForm>
					<Sort
						items={sortItems}
						value={props.query.sort}
						onChange={(sort) => props.setQuery(g => ({
							...g,
							skip: 0,
							sort
						}))}
					/>
					<FormControl variant="standard" fullWidth>
						<InputLabel>Transportauftrag Status</InputLabel>
						<Select
							value={props.query.transportOrderStatus === null ? "All" : props.query.transportOrderStatus}
							onChange={(e) => props.setQuery(g => ({
								...g,
								skip: 0,
								transportOrderStatus: (e.target.value === "All" ? null : e.target.value as TransportOrderStatus)
							}))}>
							<MenuItem value="All">Alle</MenuItem>
							<MenuItem value="Created">Erzeugt</MenuItem>
							<MenuItem value="Assigned">Zugewiesen</MenuItem>
							<MenuItem value="Cancelled">Zurückgegeben</MenuItem>
							<MenuItem value="Completed">Abgeschlossen</MenuItem>
						</Select>
					</FormControl>
					<FormControl variant="standard" fullWidth>
						<InputLabel>Rückgabestandort</InputLabel>
						<Select
							value={props.query.destinationCompound || "-"}
							onChange={(e) => {
								let value = e.target.value as string | undefined;

								if (value === "-") {
									value = undefined;
								}

								props.setQuery(g => ({
									...g,
									skip: 0,
									destinationCompound: value
								}))
							}}
						>
							<MenuItem value="-">
								Alle
							</MenuItem>
							{props.compounds?.map(c => (
								<MenuItem value={c.name} key={c.name}>
									{c.name}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</SidebarForm>
			</SidebarGroup>
			<SidebarGroup>
				<Button
					variant="outlined"
					startIcon={<RotateLeft />}
					fullWidth
					color="inherit"
					onClick={props.triggerExport}
				>
					Excel-Export
				</Button>
				<Button
					variant="outlined"
					startIcon={<GetApp />}
					fullWidth
					color="inherit"
					onClick={props.resetQuery}
				>
					Filter zurücksetzen
				</Button>
			</SidebarGroup>
		</Sidebar>
	);
};

export default VehicleArrivalsOverviewSidebar;
